export const getFirstLetter = (text) => text[0].toUpperCase();